module.exports = __webpack_public_path__ + "img/Shaman-tauren-m-1.7f60e188.gif";